import React from "react";
import { isMobile } from "react-device-detect";

import PlaylistLink from "components/boards/playlist/PlaylistLink";
import VodImage from "components/boards/post/vod/VodImage";
import VodTypeIcon from "components/boards/post/vod/VodTypeIcon";

import { ACTCODE_THUMBNAIL } from "constant/log";
import {REP_PLAYLIST} from "constant/playlist.display";

const PlaylistThumb = ({ playlist, height, inflowPath, playlistPathType }) => {
    let { bbsTitle: post = {}, count = {} } = playlist;
    // Home 의 경우 UCC가 여러개로 전달 되는 케이스가 있어서 type check 필요
    post = Array.isArray(post) ? (post[0] || {}) : (post || {});
    const ucc = post.ucc || {};

    return (
        <>
            {isMobile && (
                <span className="thum">
                    {/* 다시보기, 하이라이트 등 vod 종류별 아이콘 노출 */}
                    <VodTypeIcon fileType={ucc.file_type} auth_no={post.auth_no} />

                    {/* vod 썸네일 노출 */}
                    <VodImage vod={ucc} />

                    {/* 재생목록 대표 VOD 노출 될 경우에만 영상 갯수 노출 */}
                    {[REP_PLAYLIST].includes(playlistPathType) ? (
                            {/* 재생목록 영상 갯수 노출 */},
                            <div className="vod-count">
                                <span>{count.playlist_cnt}</span>
                            </div>
                        ) : null
                    }
                </span>
            )}

            {!isMobile && (
                <div className="thum" >
                    <PlaylistLink playlist={playlist} inflowPaths={inflowPath} playlistPathType={playlistPathType}>
                        {/* vod 썸네일 노출 */}
                        <VodImage vod={ucc} />

                        {/* 다시보기, 하이라이트 등 vod 종류별 아이콘 노출 */}
                        <VodTypeIcon fileType={ucc.file_type} auth_no={post.auth_no}/>

                        {/* 재생목록 대표 VOD 노출 될 경우에만 영상 갯수 노출 */}
                        {[REP_PLAYLIST].includes(playlistPathType) ? (
                            {/* 재생목록 영상 갯수 노출 */},
                                <div className="vod-count">
                                    <span>{count.playlist_cnt}</span>
                                </div>
                            ) : null
                        }
                    </PlaylistLink>
                </div>
            )}
        </>
    );
};

export default PlaylistThumb;
